import { Link } from "react-router-dom";

const NotFound = () => (
  <div className="flex justify-center items-center h-screen flex-col">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-24 h-24 mb-4 text-gray-400"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>

    <h1 className="font-black text-3xl mb-8">Página não encontrada!</h1>
    <Link to="/">
      <button
        type="button"
        className="bg-sky-500/100 rounded px-6 pt-2.5 pb-2 font-medium uppercase leading-normal text-white"
      >
        Voltar ao inicio
      </button>
    </Link>
  </div>
);

export default NotFound;
